import { render, staticRenderFns } from "./card-multi-input.vue?vue&type=template&id=15567582&scoped=true"
import script from "./card-multi-input.vue?vue&type=script&lang=js"
export * from "./card-multi-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15567582",
  null
  
)

export default component.exports